import { headerToken } from '@mygpt/app/apis';
import { Http } from '@mygpt/app/http';

export interface GenerationFAQsByFileParams {
  datasetId: string;
  file: File;
  count?: number;
  language?: string;
  responseType?: string;
  customPrompt?: string;
  generation_type?: 'llm' | 'template';
}

export interface GenerationSimilarQuestionsParams {
  datasetId: string;
  question: string;
  count: number;
  language?: string;
}

/**
 * 以机器人的所有文件来生成FAQs
 * @param params
 * @returns
 */
interface ImportFAQTreeResponse {
  message: string;
  success_count: number;
  fail_count: number;
  errors: string[];
  total_faqs: number;
  background_processing: boolean;
  backup_id: string;
}

// 上传文件，生成FAQs树，翻译成多语言数据
export const importFAQTree = (params: { datasetId: string; file: File }) => {
  const { datasetId, file } = params;
  const { post } = Http.use();
  const form = new FormData();
  form.append('file', file);
  return post<ImportFAQTreeResponse>(`/datasets/${datasetId}/faqs/tree_batch_import`, form);
};

/**
 * 生成相似问题
 */
export const generationSimilarQuestions = (params: GenerationSimilarQuestionsParams) => {
  const { datasetId, ...rest } = params;
  const { post } = Http.use();
  return post<string[]>(`/datasets/${datasetId}/faqs/generation/similar_questions`, rest);
};

/**
 * FAQ 生成文件参数
 */
export interface GenerationFAQsByFileSSEParams {
  datasetId: string;
  file: File;
  count?: number;
  language?: string;
  customPrompt?: string;
  generation_type?: 'llm' | 'template';
}

/**
 * 使用 SSE 从文件生成 FAQs
 * 参考 webCrawler 实现，使用 sse.js 进行 SSE 连接
 * @param params
 * @returns SSE 实例
 */
export const generationFAQsByFileSSE = (params: GenerationFAQsByFileSSEParams) => {
  const { customPrompt, datasetId, file, ...rest } = params;

  // 构建 FormData
  const form = new FormData();
  form.append('file', file);
  form.append('custom_prompt', customPrompt || '');

  // 构建 URL 参数
  const params_str = new URLSearchParams({
    response_type: 'sse',
    ...(rest.count !== undefined && { count: rest.count.toString() }),
    ...(rest.generation_type !== undefined && { generation_type: rest.generation_type }),
    ...(rest.language && { language: rest.language }),
  }).toString();

  const url = `/datasets/${datasetId}/faqs/generation/file?${params_str}`;

  // 创建 SSE 连接，使用 POST 方法传递 FormData
  // POST + 文件上传的 SSE 不应启用 autoReconnect，
  // 否则服务端关闭流后会自动重连，导致重复上传和循环请求
  const sse = Http.createEventSource(url, {
    headers: {
      Authorization: headerToken(),
    },
    autoReconnect: false,
    payload: form,
    method: 'POST',
  } as any);

  return sse;
};
